import * as ConfigAction from "./configAction"
import * as SignAction from "./signAction"
import * as CustomerAction from "./customerAction"

export default {
  ConfigAction,
  SignAction,
  CustomerAction,
}
